module.exports = __webpack_public_path__ + "img/sharing.4427305e.png";